module.exports = __webpack_public_path__ + "images/pages/for_business/sp/sec09_e7e58016ed414b52b4af5c7f7200e47e.jpg";